<script setup lang="ts">
import { HeroProps } from '~/views/cms/components/Hero.vue'

const props = defineProps<HeroProps>()
</script>

<template>
  <HeroColor v-if="!image" v-bind="props" />
  <Hero v-else v-bind="props" />
</template>
<style scoped lang="scss">
.section-hero {
  :deep(.image) {
    &:after {
      content: '';
      @include fill;
      background: linear-gradient(104deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
    }
  }
}
</style>
